import WRAP from "WRAP-JS";
import { escapeHtml } from "../../../utils/FPEUtils";

/* eslint-disable */
WRAP.Renderer.PointAreaExternal = function() {
  WRAP.Renderer.GeoJSONExtPopup.call(this);

  this.makeTooltipContent = function(rows, prop) {
    return makeContents(prop, true);
  }

  this.makeWindowContent = function(rows, prop) {
    return {
      header: prop._links_ext_name,
      body: makeContents(prop, false),
    };
  }

  const urlRegex = /(https?:\/\/[a-zA-Z0-9\-._~!#$&'()*+,/:;=?@\[\]%]+)/g;
  function makeLink(str) {
    if (typeof str === 'string') {
      const newVal = str.split(urlRegex).reduce((a, c) => {
        if(c.match(urlRegex)) {
          return a += `<a href=${c} target="_blank">${c}</a>`;
        } else {
          return a += escapeHtml(c);
        }
      }, '');
      return newVal;
    } else {
      return str;
    }
  }

  function makeContents(prop, tooltip) {
    var text = [];
    if (tooltip) {
      if (prop._links_ext_name) {
        text.push(prop._links_ext_name);
      }
    }
    Object.entries(prop).sort(([a], [b]) => a.localeCompare(b)).forEach(([key, val]) => {
      if (key.indexOf('_links_ext_') !== 0) {
        let title;
        let body;
        if (tooltip) {
          title = escapeHtml(key);
          body = escapeHtml(val);
        } else {
          title = `<span style="font-weight: bold">${escapeHtml(key)}</span>`
          body = makeLink(val);
        }
        text.push(`${title} : ${body}`);
      }
    });
    return text.join('<br/>');
  }

};
/* eslint-enable */